/**
 * Title: "Helpers for trigger form validation"
 *
 * Description: "Trigger input validation for components in UI Kit"
 * 
 * Author: tijanirf@gmail.com
 * 
 * Version:
 * - v 1.0.0 (14 March 2019): Specifically trigger validation for Input (all validation) and SelectDropdown 
 *                            (NotEmpty validation) Component.
 * 
 * 
 * @param {Object}  fields      Object that holds field values.
 *                              Example = model: {input1: null, input2: null, dropdown1: null, input3: null }.
 * 
 * @param {Object}  fieldRefs   Object that holds field custom refs, the property must be in order.
 *                              Property naming matters, for instance input property must have 'input' word, and so on.
 *                              Example = dataRef: {input1: 'input1', input2: 'input2', dropdown1: 'dropdown1', input3: 'input3'}.
 * 
 * @param {Object}  refs        Vue's $refs variable.
 * 
 * @param {Object}  errors      Object that holds field error values.
 *                              Example = error: {input1: null, input2: null, dropdown1: null, input3: null }.
 * 
 * @return {boolean}
 */


const triggerValidation = (fields, fieldRefs, refs, errors) => {
  let isValid = true

  for (let key in fieldRefs) {
    if (key.toLowerCase().includes('input')) {
        isValid = triggerInput(refs[key],errors, key)
        if (!isValid) break;

    } else if (key.toLowerCase().includes('dropdown')) {
        isValid = triggerDropdown(fields, errors, key)
        if (!isValid) break;

    } else if (key.toLowerCase().includes('object')) {
      let fieldObject = fieldRefs[key]
      console.log('object', fieldObject)
      for (let objkey in fieldObject) {
        console.log('objkey', objkey)
        if(objkey.toLowerCase().includes('input')){
          isValid = triggerInput(refs[objkey], errors, objkey)
          if (!isValid) break;

        } else if (objkey.toLowerCase().includes('dropdown')){
          isValid = triggerDropdownObj(fields, errors, key, objkey)
          if (!isValid) break;

        }
      }
    }
  }

  return isValid
}

/**
 * 
 * @param {*} refs 
 * @param {*} errors 
 * @param {*} key 
 */
const triggerInput = (refs, errors, key) => {
  console.log('refs', refs, 'error', errors, 'key', key)
  let element = null
  
  if (refs.constructor.name=='Array') {
    console.log()
    for (let i = 0 ; i < refs.length; i++){
      element = refs[i].$el.firstElementChild
      element.focus()
      element.blur()
      if (errors[key][i]) {
        return false
      }
    }
  } else {
    element = refs.$el.firstElementChild
    element.focus()
    element.blur()
    console.log('element', element)
    if (errors[key]) {
      return false
    }
  }
  return true
}

/**
 * 
 * @param {*} fields 
 * @param {*} errors 
 * @param {*} key 
 */
const triggerDropdownObj = (fields, errors, key, objkey) => {

  let isValid = true
  if (fields[key].constructor.name=='Array') {
    console.log(fields[key], 'fields[key]')
    for (let i=0; i < fields[key].length; i++) {
      isValid = triggerDropdown(fields[key][i], errors[key], objkey)
    }
    
  } else {
    isValid = triggerDropdown(fields, errors, key)
  }

  return isValid
}

/**
 * 
 * @param {*} fields 
 * @param {*} errors 
 * @param {*} key 
 */
const triggerDropdown = (fields, errors, key) => {
  if (fields[key] && fields[key].constructor.name=='Array') {
    for (let i = 0 ; i < fields[key].length; i++){
      fields[key][i] = ''
      if (errors[key][i] != false) {
        return false
      }
    }
  } else {
    fields[key] = ''
    if (errors[key] != false) {
      return false
    }
  }
  return true
}

export default triggerValidation;